module.exports = __webpack_public_path__ + "static/semantic-card-fluid-4b1b375b9bd5af676ee30c921634263c.png";